export default {
  path: '/departments',
  component: () => import(
    /* webpackChunkName: "departments-list" */
    /* webpackPrefetch: true */
    './List'
  ),
  children: [
    {
      path: 'create',
      component: () => import(
        /* webpackChunkName: "departments-create" */
        /* webpackPrefetch: true */
        './Create'
      ),
    },
    {
      path: ':id',
      component: () => import(
        /* webpackChunkName: "departments-detail" */
        /* webpackPrefetch: true */
        './Detail'
      ),
    },
  ],
};
